import type { GlobalScholar } from "@lib/types/scientist-profile";
import { getScientistIndexLabel } from "@lib/indexLabelHelpers";

function generateUniversityUrl(universitySlug: string, disciplineSlug: string, isSpecial: boolean): string {
    return isSpecial || !disciplineSlug
        ? `/university/${universitySlug}`
        : `/university/${disciplineSlug}/${universitySlug}`;
}

export function getGlobalScientistsTableItemTemplate(
    scientist: GlobalScholar,
    disciplineSlug: string,
    isSpecial: boolean,
): string {
    const indexLabel = getScientistIndexLabel(disciplineSlug);

    return `<div class="cols scientist-item rankings-content__item">
        <span class="col col--1 cols col--tablet mx-0 py-0 px-0 center positions">
            <span class="col col--3 py-0 px-0 position">
                ${scientist.worldPosition || "N/A"}
                <span class="show-tablet desc">World</span>
            </span>
            <span class="col col--3 py-0 px-0 position">
                ${scientist.nationalPosition || "N/A"}
                <span class="show-tablet desc">National</span>
            </span>
        </span>
        <div class="col col--5-12 cols col--tablet mx-0 py-0 info">
            <span class="col col--1 px-0 py-0 img">
                <img src="${scientist.thumbnail}" alt="${scientist.fullName}" onerror="src = '/classic-rankings-frontend/images/placeholder-scholar.svg'" width="64" height="64" loading="lazy" decoding="async" />
            </span>
            <div class="col col--5 col--tablet">
                <h4><a href="/u/${scientist.slug}" class="scientist-name-clamp" target="_blank">${scientist.fullName}</a></h4>
                <span class="sh">
                    <a href="${generateUniversityUrl(scientist.institution.slug, disciplineSlug, isSpecial)}" title="Read more" target="_blank">
                        ${scientist.institution.name},
                        ${scientist.country.name}
                    </a>
                </span>
            </div>
        </div>
        <span class="col col--5-12 py-0 cols mx-0 rankings-info">
            <span class="col col--2 col--tablet py-0 ranking">
                <span class="show-tablet desc">${indexLabel}</span>
                <span class="ranking no-wrap">${scientist.hIndex || "N/A"}</span>
            </span>
            <span class="col col--2 col--tablet tablet-no-border py-0 ranking">
                <span class="show-tablet desc">Citations</span>
                <span class="ranking no-wrap">${scientist.citations?.toLocaleString() || "N/A"}</span>
            </span>
            <span class="col col--2 py-0 hide-tablet ranking">
                <span class="col col--3 py-0 ranking no-wrap">${scientist.publications?.toLocaleString() || "N/A"}</span>
            </span>
        </span>
    </div>`;
}
